import { UniFiCategoryId, UniFiChildCategorySlug } from '../../../proStoreCategories/mapping/unifi.mjs';
import { SiteId } from '../../../../contexts/MenuContext/mapping.mjs';
import '../../assets/Assets-V4/WiFi/u7-pr-xg@2x.jpg.mjs';
import '../../assets/Flagship/u7-pro-xg.jpg.mjs';
import { wifiFlagship } from '../product-list-groups/wifi-flagship.mjs';
import '../properties/index.mjs';
import { dimensions } from '../properties/dimensions.mjs';
import { wifiTechnology } from '../properties/wifiTechnology.mjs';
import { radio6Ghz } from '../properties/radio6Ghz.mjs';
import { wifiCoverage } from '../properties/coverage.mjs';
import { connectedDevices } from '../properties/connectedDevices.mjs';
import { uplink } from '../properties/uplink.mjs';
import v3Image__default from "../../../../assets/u7-pro-xg.jpg";
import image__default from "../../../../assets/u7-pr-xg@2x.jpg";
"use strict";
const u7proXg = {
  id: "u7proXg",
  productTitle: "U7 Pro XG",
  description: "u7proXg.description",
  storePathParts: {
    category: UniFiChildCategorySlug.WiFiFlagship,
    productSlug: "u7-pro-xg"
  },
  techspecsPath: [SiteId.TechSpecs, `/unifi/${UniFiCategoryId.WiFi}/u7-pro-xg`],
  image: {
    src: image__default,
    width: 200,
    height: 160
  },
  productListGroup: wifiFlagship,
  v3Image: {
    src: v3Image__default,
    width: 205,
    height: 182
  },
  isNew: true,
  propertyValues: [{
    propertyId: dimensions.id,
    value: {
      type: "translation",
      value: "u7proXg.dimensions"
    }
  }, {
    propertyId: wifiTechnology.id,
    value: {
      type: "translation",
      value: "u7proXg.wifiTechnology"
    }
  }, {
    propertyId: radio6Ghz.id,
    value: {
      type: "boolean",
      value: true
    }
  }, {
    propertyId: wifiCoverage.id,
    value: {
      type: "string",
      value: "140 m\xB2 (1,500 ft\xB2)"
    }
  }, {
    propertyId: connectedDevices.id,
    value: {
      type: "string",
      value: "300+"
    }
  }, {
    propertyId: "powerMethodPoe",
    value: {
      type: "string",
      value: "PoE+"
    }
  }, {
    propertyId: uplink.id,
    value: {
      type: "string",
      value: "10/5/2.5/1 GbE"
    }
  }, {
    propertyId: "radios",
    value: {
      type: "boolean",
      value: false
    }
  },
  // MUST HAVE FOR OVERVIEW SECTION
  {
    propertyId: "extendedRangeMode6Ghz",
    value: {
      type: "boolean",
      value: false
    }
  }, {
    propertyId: "rfFilteringTechnology",
    value: {
      type: "boolean",
      value: false
    }
  }, {
    propertyId: "antennaType",
    value: {
      type: "translation",
      value: "antennaType.omnidirectional"
    }
  }, {
    propertyId: "weatherproofing",
    value: {
      type: "boolean",
      value: false
    }
  }, {
    propertyId: "redundantRj45Port",
    value: {
      type: "boolean",
      value: false
    }
  }, {
    propertyId: "wifiMounting",
    value: {
      type: "translation",
      value: "commons.mounting.ceilingWall"
    }
  }]
};
export { u7proXg };
//# sourceMappingURL=u7proXg.mjs.map
